<h3>{{'Please scan a RFID card' | translate }}</h3>
<div class="image-container">
  <img src="static/images/scan/scan_card.png">
</div>
<app-backward-forward (backwardClick)="onBack()" [hideNext]="true"></app-backward-forward>
